module.exports = __webpack_public_path__ + "img/mamelodi-sundowns-logo-icon.067ac1af.png";